<template>
    <form v-on:submit="save">
        <div>
            <div class="card card-info">
                <div class="card-header">
                    <h3 class="card-title" style="width: 100%">
                        Filters
                    </h3>
                </div>
                <div class="card-body" style="padding-left: 1%; padding-right: 1%; padding-top: 1%">
                    <div class="row">
                        <div class="col-md-4">
                            Session *
                            <select class="form-control" v-model="filter.SemesterID" v-on:change="getprograms()">
                                <option value="0">--Select Session--</option>
                                <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
                            </select>
                        </div>

                        <div class="col-md-4">
                            Program
                            <select class="form-control" v-model="filter.ProgramID">
                                <option value="0">--Select Program--</option>
                                <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                            </select>
                        </div>

                        <div class="col-md-4">
                            Batch
                            <select class="form-control" v-model="filter.SessionID">
                                <option value="0">--Select Batch--</option>
                                <option v-for="item in sessions" v-bind:value="item.SessionID">{{item.Name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="card-footer bg-light" style="text-align: right">
                    <button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="btnSearch()">Search</button>
                    <button class="btn btn-danger" style="margin-top: 20px;" runat="server">Cancel</button>
                </div>
            </div>

            <div class="card card-info">
                <div class="card-body" style="padding-left: 1%; padding-right: 1%; padding-top: 1%">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <!--<%--<label>Select</label>
                                <select class="form-control">
                                  <option>{{}}</option>
                                </select>--%>-->
                            </div>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 10px">
                        <div class="col-md-12">
                            <hr />
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered table-color">
                                    <thead class="bg-info text-white">
                                        <tr>
                                            <th style="width: 5px; text-align: center">Sr.#</th>
                                            <th style="width: 70px">Form No.</th>
                                            <th style="width: 15%">Name</th>
                                            <th style="width: 15%">Father Name</th>
                                            <th style="width: 10%">CNIC</th>
                                            <th style="width: 15%">Section</th>
                                            <th colspan="3">Registration No.</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="5"></td>
                                            <td>
                                                <select class="form-control" v-model="sectionID">
                                                    <option value="">--Select Section--</option>
                                                    <option v-for="item in sections" v-bind:value="item.SectionID">{{item.Name}}</option>
                                                </select>
                                            </td>
                                            <td>
                                                <input class="form-control" placeholder="Prefix" v-model="prefix" />
                                            </td>
                                            <td>
                                                <input class="form-control" v-mask="'####'" placeholder="Num" v-model="num" />
                                            </td>
                                            <td>
                                                <input class="form-control" placeholder="Postfix" v-model="postfix" />
                                            </td>
                                            <td>
                                                <button class="btn btn-sm btn-primary" type="button" v-on:click="btnApply()">Apply</button>
                                            </td>
                                        </tr>
                                        <tr v-bind:style="p.StudentRegistrationID != 0 ? 'color: orangered': ''" v-for="(p, ind) in prospects">
                                            <td style="text-align: center; vertical-align: middle">{{ind + 1}}</td>

                                            <td style="vertical-align: middle">{{p.FormNo}}</td>
                                            <td style="vertical-align: middle">
                                                {{p.Name}}
                                            </td>
                                            <td style="vertical-align: middle">{{p.FathersName}}</td>
                                            <td style="vertical-align: middle">{{p.CNIC}}</td>
                                            <td style="vertical-align: middle" style="vertical-align: middle; text-align: center">
                                                <select class="form-control" v-model="p.SectionID" required v-bind:disabled="p.StudentRegistrationID != 0">
                                                    <option value="" disabled>--Select Section--</option>
                                                    <option v-for="item in sections" v-if="p.StudentRegistrationID == 0" v-bind:value="item.SectionID">{{item.Name}}</option>
                                                </select>
                                            </td>
                                            <td colspan="3" style="vertical-align: middle; text-align: center">{{p.RegistrationNo}}</td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-footer bg-light" style="text-align: right">
                    <button class="btn btn-success" type="submit" v-if="prospects.length > 0" style="margin-top: 20px;">Save</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>const axios = require('axios').default;

    export default ({
        data() {
            return {
                departments: [],
                programs: [],
                selDegreeID: 0,
                semesters: [],
                degrees: [],
                filter: { SemesterID: 0, ProgramID: 0, DepartmentID: 0, DegreeID: 0, Name: '', SessionID: 0 },
                prospects: [],
                Types: 0,
                exceldata: [],
                exceldatastatus: 'default',
                prefix: '',
                num: '',
                postfix: '',
                sectionID: '',
                sections: []
            }
        },

        created: function () {
            this.pageLoad();
        },

        methods:
        {
            pageLoad: function () {
                var vm = this;
                startReq();

                axios.post('/api/AdmissionApi/prospectstudentEnrollmentPageLoad')
                    .then(function (pl) {
                        vm.semesters = pl.data.sem;
                        vm.sessions = pl.data.session;
                        vm.degrees = pl.data.deg;
                        endReq();
                    })
            },

            getprograms() {
                var vm = this;
                startReq();
                axios.post('/api/AdmissionApi/loadProgramStudentEnrollment?semesterID=' + vm.filter.SemesterID)
                    .then(function (res) {
                        vm.programs = res.data.cat;
                        endReq();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            loadPrograms() {
                var vm = this;
                vm.prospects = [];

                startReq();
                axios.post('/api/AdmissionApi/loadProgramStudentEnrollment?ID=' + vm.filter.SemesterID)
                    .then(function (res) {
                        vm.programs = res.data;
                        endReq();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            btnSearch() {
                startReq();
                var vm = this;
                if (vm.filter.SemesterID == 0) {
                    toastr.error("Please select Session", "Error!");
                    endReq();
                }
                else if (vm.filter.ProgramID == 0) {
                    toastr.error("Please select Program", "Error!");
                    endReq();
                }
                else if (vm.filter.SessionID == 0) {
                    toastr.error("Please select Batch", "Error!");
                    endReq();
                }
                else {
                    axios.post('/api/AdmissionApi/searchProspectStudentForEnrollment?programID=' + vm.filter.ProgramID + '&batch=' + vm.filter.SessionID + '&semesterID=' + vm.filter.SemesterID)
                        .then(function (res) {
                            vm.prospects = [];
                            vm.prospects = res.data.data;
                            vm.exceldatastatus = "enabled";
                            axios.post('/api/AdmissionApi/loadsectionsbyadmissionoffered?programID=' + vm.filter.ProgramID + '&batch=' + vm.filter.SessionID)
                                .then(function (resp) {
                                    vm.sections = resp.data.section;
                                    endReq();
                                })
                                .catch(function (error) {
                                    console.log(error);
                                })
                        })
                        .catch(function (error) {
                            console.log(error);
                        })
                }

            },

            btnApply() {
                var vm = this;
                var inc = Number(vm.num);
                vm.prospects.forEach(function (item) {
                    inc = inc.toString().padStart(4, 0);
                    if (item.StudentRegistrationID == 0) {
                        item.RegistrationNo = vm.prefix + inc + vm.postfix;
                        item.SectionID = vm.sectionID;
                        inc++;
                    }
                });
            },

            save: function (e) {
                e.preventDefault();
                var vm = this;
              for (var i = 0; i < vm.prospects.length; i++)
              {
                    if (vm.prospects[i].StudentRegistrationID == 0 && (vm.prospects[i].RegistrationNo == '' || vm.prospects[i].RegistrationNo == null)) {
                        toastr.error("Registration No Required for All students", "Error!");
                        return;
                    }
              }
                startReq();
                axios.post('/api/AdmissionApi/enrollProspectStudents', {
                    prospects: vm.prospects
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status == false) {
                            toastr.error(res.data.msg, "Error!");
                        }
                        else {
                            toastr.success("Saved Successfully", "Done!");
                            vm.prospects = [];
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            }
        }
    });

    function redirect_blank(url) {
        var a = document.createElement('a');
        a.target = "_blank";
        a.href = url;
        a.click();
    }</script>

<style>

    blink {
        -webkit-animation: 2s linear infinite condemned_blink_effect;
    }

    @-webkit-keyframes condemned_blink_effect {

        0% {
            visibility: hidden;
        }

        50% {
            visibility: hidden;
        }

        100% {
            visibility: visible;
        }
    }

    @keyframes condemned_blink_effect {
        0% {
            visibility: hidden;
        }

        50% {
            visibility: hidden;
        }

        100% {
            visibility: visible;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/ProspectStudentEnrollment.vue